import React from 'react';
import moment from 'moment';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import DatePicker from 'react-datepicker';

import { TableComponent, connect } from '../tableComponent';
import Sublogin from '../elements/sublogin';
import Message from './message';

class Component extends TableComponent {
  initialState = {
    // from: moment().isoWeekday(1).subtract(1, 'week'),
    // to: moment().isoWeekday(1).subtract(1, 'week').add(6, 'days'),
    // bonusSaleDate: moment().isoWeekday(1).subtract(1, 'week').add(3, 'days'),
    from: moment().isoWeekday(1),
    to: moment().isoWeekday(1).add(6, 'days'),
    bonusSaleDate: moment().isoWeekday(1).add(3, 'days'),
    minSales: 3,
    inProgress: false,
    addingBonusSales: false,
    addedBonusSales: -1,
    removingBonusSales: false,
    removedBonusSales: -1,

    autosalesMinSales: 3,
    autosalesEnabled: false,
    autosalesSaving: false
  };

  state = {
    error: '',
    messageModalOpen: false
  };

  componentDidMount() {
    // this.verifyStates();
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.data.settings && this.props.data.settings) {
      this.verifyStates();
    }
  }

  verifyStates = () => {
    let { minSales, enabled } = this.props.data.settings;
    minSales = parseInt(minSales) || 3;
    console.log('verifyStates', minSales, enabled);
    this.props.setState(
      {
        autosalesMinSales: minSales,
        autosalesEnabled: enabled,
        minSales
      },
      this.fetchData
    );
  };

  makeColumns = () => {
    const columns = [
      {
        Header: 'Wid',
        accessor: 'aid',
        minWidth: 60,
        Footer: (props) => <span>Total</span>
      },
      {
        Header: 'Owner',
        accessor: 'owner_wid',
        minWidth: 60,
        Cell: ({ original }) => <span>{original.master_wid || original.owner_wid}</span>,
        Footer: (props) => <span>{this.props.total.count || 0}</span>
      },
      {
        Header: 'Name',
        accessor: 'lastname',
        sortable: false,
        minWidth: 150,
        Cell: (props) => <span>{props.original.firstname + ' ' + props.original.lastname}</span>
      },
      {
        Header: 'Email',
        accessor: 'email',
        sortable: false,
        minWidth: 150,
        Cell: (props) => <span>{props.original.email}</span>
      },
      // {
      //   Header: 'Owner',
      //   accessor: 'email',
      //   sortable: false,
      //   minWidth: 180,
      //   Cell: ({ original }) => (
      //     <span>
      //       {original.owner_firstname + ' ' + original.owner_lastname + ' ' + original.owner_email}
      //     </span>
      //   )
      // },
      {
        Header: 'Today',
        accessor: 'today_sales',
        minWidth: 130,
        Cell: ({ original }) => (
          <div>
            {original.today_sales} sales / {original.today_bonus_sales} bonus
          </div>
        ),
        Footer: (props) => <div>{this.props.total.today_sales || 0} sales</div>
      },
      {
        Header: 'Yesterday',
        accessor: 'yesterday_sales',
        minWidth: 130,
        Cell: ({ original }) => (
          <div>
            {original.yesterday_sales} sales / {original.yesterday_bonus_sales} bonus
          </div>
        ),
        Footer: (props) => <div>{this.props.total.yesterday_sales || 0} sales</div>
      },
      {
        Header: 'Last week',
        accessor: 'week_sales',
        minWidth: 130,
        Cell: ({ original }) => (
          <div>
            {original.week_sales} sales / {original.week_bonus_sales} bonus
          </div>
        ),
        Footer: (props) => <div>{this.props.total.week_sales || 0} sales</div>
      },
      {
        Header: (props) =>
          this.props.state.from.format('D MMM') + ' - ' + this.props.state.to.format('D MMM'),
        accessor: 'between_sales',
        minWidth: 130,
        Cell: ({ original }) => (
          <div>
            {original.between_sales} sales / {original.between_bonus_sales} bonus
          </div>
        ),
        Footer: (props) => <div>{this.props.total.between_sales || 0} sales</div>
      },
      {
        Header: '',
        accessor: 'aid',
        id: 'login',
        sortable: false,
        minWidth: 80,
        Cell: (props) => <Sublogin aid={props.value} class='' />
      }
    ];
    return columns;
  };

  apiPath = 'bonus/agents';

  fetchParams = () => {
    return {
      minSales: this.props.state.minSales || 2
    };
  };

  tableParams = {
    manual: true,
    showAll: true,
    sorted: [
      {
        id: 'aid',
        desc: true
      }
    ],
    defaultPageSize: 100
  };

  addSaleAll = async () => {
    let { items } = this.props;
    this.props.setState({ inProgress: true, addingBonusSales: true, addedBonusSales: 0 });
    let succeed = 0;
    let failed = 0;
    let success;
    for (let i = 0; i < items.length; i++) {
      success = await this.addSale(i);
      if (success) succeed += 1;
      if (!success) failed += 1;
      this.props.setState({ addedBonusSales: succeed });
    }
    this.props.setState({ inProgress: false, addingBonusSales: false });
    this.fetchData({ forceReload: true });
  };

  removeSaleAll = async () => {
    let { items } = this.props;
    this.props.setState({ inProgress: true, removingBonusSales: true, removedBonusSales: 0 });
    let succeed = 0;
    let failed = 0;
    let success;
    for (let i = 0; i < items.length; i++) {
      success = await this.removeSale(i);
      if (success) succeed += 1;
      if (!success) failed += 1;
      this.props.setState({ removedBonusSales: succeed });
    }
    this.props.setState({ inProgress: false, removingBonusSales: false });
    this.fetchData({ forceReload: true });
  };

  addSale = async (index) => {
    // console.log('addSale', props);
    let item = this.props.items[index];
    item.loading = true;
    item.addingBonus = true;
    this.props.changeItems(this.props.items);
    let res = await this.props.api('bonus/add_sale', {
      aid: item.aid,
      owner_wid: item.owner_wid,
      day: this.props.state.bonusSaleDate.format('DD-MM-YYYY')
    });
    item = this.props.items[index];
    item.loading = false;
    item.addingBonus = false;
    let success = res === 'OK';
    if (success) {
      // item.between_bonus_sales = parseInt(item.bonus_sales) + 1;
      // item.between_sales = parseInt(item.between_sales) + 1;
      item.addedBonusSale = true;
    } else {
      item.addedBonusSaleFailed = true;
      console.log('addSale error', res);
      alert('Error: ' + res);
    }
    this.props.changeItems(this.props.items);
    return success;
  };

  removeSale = async (index) => {
    let item = this.props.items[index];
    item.removeSaleLoading = true;
    this.props.changeItems(this.props.items);
    let res = await this.props.api('bonus/remove_sale', {
      aid: item.aid,
      owner_wid: item.owner_wid,
      day: this.props.state.bonusSaleDate.format('DD-MM-YYYY')
    });
    item = this.props.items[index];
    item.loading = false;
    let success = res === 'OK';
    if (success) {
      // item.between_bonus_sales = parseInt(item.bonus_sales) - 1;
      // item.between_sales = parseInt(item.between_sales) - 1;
      item.removedBonusSale = true;
    } else {
      item.removedBonusSaleFailed = true;
      console.log('removeSale error', res);
      alert('Error: ' + res);
    }
    this.props.changeItems(this.props.items);
    return success;
  };

  onChangeMinSales = (e) => {
    this.props.setState({ minSales: e.target.value }, this.fetchData);
  };

  onChangeAutosalesMinSales = (e) => {
    this.props.setState({ autosalesMinSales: e.target.value }, this.saveSettings);
  };

  onChangeAutosalesEnabled = (val) => {
    this.props.setState({ autosalesEnabled: val }, this.saveSettings);
  };

  saveSettings = () => {
    clearTimeout(this.saveSettingsTimeout);
    this.saveSettingsTimeout = setTimeout(() => {
      this.props.api('bonus/saveSettings', {
        settings: {
          minSales: this.props.state.autosalesMinSales,
          enabled: this.props.state.autosalesEnabled
        }
      });
    }, 500);
  };

  render() {
    let wids = this.props.items.map((item) => item.aid).join(',');
    let { inProgress, addingBonusSales, addedBonusSales, removingBonusSales, removedBonusSales } =
      this.props.state;
    let autosalesEnabled = this.props.state.autosalesEnabled || this.initialState.autosalesEnabled;
    return (
      <div class='co__pg-agents'>
        {this.state.messageModalOpen && (
          <Message wids={wids} onClose={() => this.setState({ messageModalOpen: false })} />
        )}
        <div class='row'>
          <div class='col-sm col-sm-12 text-center co__table-filters'>
            <div class='pull-left mr-2'>
              {this.datepickerElement({ disabled: inProgress, weekArrows: true })}
            </div>
            <div class='pull-left'>
              <span class='p-2'>Min sales:</span>
              <input
                class={'form-control form-control-sm d-inline-block'}
                style={{
                  width: '50px'
                }}
                type='number'
                name='minSales'
                disabled={inProgress}
                value={this.props.state.minSales || this.initialState.minSales}
                onChange={this.onChangeMinSales}
              />
            </div>
            <div class='pull-left'>
              <button
                class='btn warning ml-3'
                onClick={(e) => this.setState({ messageModalOpen: true })}
              >
                Message
              </button>
            </div>
            <div class='pull-right'>
              <div class='d-inline-block table-datepicker-wrap'>
                <DatePicker
                  selected={this.props.state.bonusSaleDate}
                  onChange={(bonusSaleDate) => this.props.setState({ bonusSaleDate })}
                  popperPlacement='bottom-start'
                  class='form-control form-control-sm table-datepicker'
                  dateFormat='D MMM YYYY'
                  disabled={inProgress}
                />
              </div>
              <button class='btn success ml-3' onClick={this.addSaleAll} disabled={inProgress}>
                {!addingBonusSales && 'Add bonus'}
                {addingBonusSales && 'Adding...'}
              </button>
              {addedBonusSales >= 0 && <span class='ml-1'>{addedBonusSales}</span>}
              <button class='btn danger ml-2' onClick={this.removeSaleAll} disabled={inProgress}>
                {!removingBonusSales && 'Remove bonus'}
                {removingBonusSales && 'Removing...'}
              </button>
              {removedBonusSales >= 0 && <span class='ml-1'>{removedBonusSales}</span>}
            </div>
          </div>
        </div>
        {!!this.props.data.settings && (
          <div class='row'>
            <div class='col-sm col-sm-12 text-center co__table-filters'>
              <div class='pull-left'>
                <span class='p-2'>
                  <b>Autosales config</b>
                </span>
                <span class='p-2'>Min sales:</span>
                <input
                  class={'form-control form-control-sm d-inline-block'}
                  style={{
                    width: '50px'
                  }}
                  type='number'
                  name='autosalesMinSales'
                  disabled={inProgress}
                  value={this.props.state.autosalesMinSales || this.initialState.autosalesMinSales}
                  onChange={this.onChangeAutosalesMinSales}
                />
              </div>
              <div class='pull-left'>
                <button
                  class='btn warning ml-3'
                  onClick={() => this.onChangeAutosalesEnabled(!autosalesEnabled)}
                >
                  {autosalesEnabled ? 'Enabled' : 'Disabled'}
                </button>
              </div>
            </div>
          </div>
        )}
        <div class='row'>
          <div class='col-sm-12'>
            <div class='box mt-2'>{this.reactTable()}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(Component, 'bonus_agents', function (state) {
  return {
    apiChangeState: state.api.affiliate_agent_edit || state.api.initial,
    apiSaveSettingsState: state.api.bonus_saveSettings || state.api.initial,
    date: Date.now()
  };
});
